// console.log('app connected')
//import the website pages


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e943a7bafefa26a3$var$t = globalThis, $e943a7bafefa26a3$var$i = $e943a7bafefa26a3$var$t.trustedTypes, $e943a7bafefa26a3$var$s = $e943a7bafefa26a3$var$i ? $e943a7bafefa26a3$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e943a7bafefa26a3$var$e = "$lit$", $e943a7bafefa26a3$var$h = `lit$${(Math.random() + "").slice(9)}$`, $e943a7bafefa26a3$var$o = "?" + $e943a7bafefa26a3$var$h, $e943a7bafefa26a3$var$n = `<${$e943a7bafefa26a3$var$o}>`, $e943a7bafefa26a3$var$r = document, $e943a7bafefa26a3$var$l = ()=>$e943a7bafefa26a3$var$r.createComment(""), $e943a7bafefa26a3$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e943a7bafefa26a3$var$a = Array.isArray, $e943a7bafefa26a3$var$u = (t)=>$e943a7bafefa26a3$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e943a7bafefa26a3$var$d = "[ 	\n\f\r]", $e943a7bafefa26a3$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e943a7bafefa26a3$var$v = /-->/g, $e943a7bafefa26a3$var$_ = />/g, $e943a7bafefa26a3$var$m = RegExp(`>|${$e943a7bafefa26a3$var$d}(?:([^\\s"'>=/]+)(${$e943a7bafefa26a3$var$d}*=${$e943a7bafefa26a3$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e943a7bafefa26a3$var$p = /'/g, $e943a7bafefa26a3$var$g = /"/g, $e943a7bafefa26a3$var$$ = /^(?:script|style|textarea|title)$/i, $e943a7bafefa26a3$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e943a7bafefa26a3$export$c0bb0b647f701bb5 = $e943a7bafefa26a3$var$y(1), $e943a7bafefa26a3$export$7ed1367e7fa1ad68 = $e943a7bafefa26a3$var$y(2), $e943a7bafefa26a3$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e943a7bafefa26a3$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e943a7bafefa26a3$var$A = new WeakMap, $e943a7bafefa26a3$var$E = $e943a7bafefa26a3$var$r.createTreeWalker($e943a7bafefa26a3$var$r, 129);
function $e943a7bafefa26a3$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e943a7bafefa26a3$var$s ? $e943a7bafefa26a3$var$s.createHTML(i) : i;
}
const $e943a7bafefa26a3$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $e943a7bafefa26a3$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e943a7bafefa26a3$var$f ? "!--" === u[1] ? c = $e943a7bafefa26a3$var$v : void 0 !== u[1] ? c = $e943a7bafefa26a3$var$_ : void 0 !== u[2] ? ($e943a7bafefa26a3$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e943a7bafefa26a3$var$m) : void 0 !== u[3] && (c = $e943a7bafefa26a3$var$m) : c === $e943a7bafefa26a3$var$m ? ">" === u[0] ? (c = r ?? $e943a7bafefa26a3$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e943a7bafefa26a3$var$m : '"' === u[3] ? $e943a7bafefa26a3$var$g : $e943a7bafefa26a3$var$p) : c === $e943a7bafefa26a3$var$g || c === $e943a7bafefa26a3$var$p ? c = $e943a7bafefa26a3$var$m : c === $e943a7bafefa26a3$var$v || c === $e943a7bafefa26a3$var$_ ? c = $e943a7bafefa26a3$var$f : (c = $e943a7bafefa26a3$var$m, r = void 0);
        const x = c === $e943a7bafefa26a3$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e943a7bafefa26a3$var$f ? s + $e943a7bafefa26a3$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e943a7bafefa26a3$var$e + s.slice(d) + $e943a7bafefa26a3$var$h + x) : s + $e943a7bafefa26a3$var$h + (-2 === d ? i : x);
    }
    return [
        $e943a7bafefa26a3$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $e943a7bafefa26a3$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e943a7bafefa26a3$var$P(t, s);
        if (this.el = $e943a7bafefa26a3$var$V.createElement(f, n), $e943a7bafefa26a3$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e943a7bafefa26a3$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e943a7bafefa26a3$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e943a7bafefa26a3$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e943a7bafefa26a3$var$k : "?" === e[1] ? $e943a7bafefa26a3$var$H : "@" === e[1] ? $e943a7bafefa26a3$var$I : $e943a7bafefa26a3$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($e943a7bafefa26a3$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e943a7bafefa26a3$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e943a7bafefa26a3$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e943a7bafefa26a3$var$i ? $e943a7bafefa26a3$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e943a7bafefa26a3$var$l()), $e943a7bafefa26a3$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e943a7bafefa26a3$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e943a7bafefa26a3$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e943a7bafefa26a3$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e943a7bafefa26a3$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e943a7bafefa26a3$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e943a7bafefa26a3$var$N(t, i, s = t, e) {
    if (i === $e943a7bafefa26a3$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e943a7bafefa26a3$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e943a7bafefa26a3$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $e943a7bafefa26a3$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e943a7bafefa26a3$var$r).importNode(i, !0);
        $e943a7bafefa26a3$var$E.currentNode = e;
        let h = $e943a7bafefa26a3$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e943a7bafefa26a3$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e943a7bafefa26a3$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e943a7bafefa26a3$var$E.nextNode(), o++);
        }
        return $e943a7bafefa26a3$var$E.currentNode = $e943a7bafefa26a3$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e943a7bafefa26a3$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e943a7bafefa26a3$var$N(this, t, i), $e943a7bafefa26a3$var$c(t) ? t === $e943a7bafefa26a3$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e943a7bafefa26a3$export$45b790e32b2810ee && this._$AR(), this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee) : t !== this._$AH && t !== $e943a7bafefa26a3$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e943a7bafefa26a3$var$u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== $e943a7bafefa26a3$export$45b790e32b2810ee && $e943a7bafefa26a3$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e943a7bafefa26a3$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e943a7bafefa26a3$var$V.createElement($e943a7bafefa26a3$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e943a7bafefa26a3$var$S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e943a7bafefa26a3$var$A.get(t.strings);
        return void 0 === i && $e943a7bafefa26a3$var$A.set(t.strings, i = new $e943a7bafefa26a3$var$V(t)), i;
    }
    k(t) {
        $e943a7bafefa26a3$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e943a7bafefa26a3$var$M(this.S($e943a7bafefa26a3$var$l()), this.S($e943a7bafefa26a3$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e943a7bafefa26a3$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e943a7bafefa26a3$var$N(this, t, i, 0), o = !$e943a7bafefa26a3$var$c(t) || t !== this._$AH && t !== $e943a7bafefa26a3$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e943a7bafefa26a3$var$N(this, e[s + n], i, n), r === $e943a7bafefa26a3$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e943a7bafefa26a3$var$c(r) || r !== this._$AH[n], r === $e943a7bafefa26a3$export$45b790e32b2810ee ? t = $e943a7bafefa26a3$export$45b790e32b2810ee : t !== $e943a7bafefa26a3$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e943a7bafefa26a3$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e943a7bafefa26a3$var$k extends $e943a7bafefa26a3$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e943a7bafefa26a3$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e943a7bafefa26a3$var$H extends $e943a7bafefa26a3$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e943a7bafefa26a3$export$45b790e32b2810ee);
    }
}
class $e943a7bafefa26a3$var$I extends $e943a7bafefa26a3$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e943a7bafefa26a3$var$N(this, t, i, 0) ?? $e943a7bafefa26a3$export$45b790e32b2810ee) === $e943a7bafefa26a3$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e943a7bafefa26a3$export$45b790e32b2810ee && s !== $e943a7bafefa26a3$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e943a7bafefa26a3$export$45b790e32b2810ee && (s === $e943a7bafefa26a3$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e943a7bafefa26a3$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e943a7bafefa26a3$var$N(this, t);
    }
}
const $e943a7bafefa26a3$export$8613d1ca9052b22e = {
    P: $e943a7bafefa26a3$var$e,
    A: $e943a7bafefa26a3$var$h,
    C: $e943a7bafefa26a3$var$o,
    M: 1,
    L: $e943a7bafefa26a3$var$P,
    R: $e943a7bafefa26a3$var$S,
    D: $e943a7bafefa26a3$var$u,
    V: $e943a7bafefa26a3$var$N,
    I: $e943a7bafefa26a3$var$M,
    H: $e943a7bafefa26a3$var$R,
    N: $e943a7bafefa26a3$var$H,
    U: $e943a7bafefa26a3$var$I,
    B: $e943a7bafefa26a3$var$k,
    F: $e943a7bafefa26a3$var$L
}, $e943a7bafefa26a3$var$Z = $e943a7bafefa26a3$var$t.litHtmlPolyfillSupport;
$e943a7bafefa26a3$var$Z?.($e943a7bafefa26a3$var$V, $e943a7bafefa26a3$var$M), ($e943a7bafefa26a3$var$t.litHtmlVersions ??= []).push("3.1.2");
const $e943a7bafefa26a3$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e943a7bafefa26a3$var$M(i.insertBefore($e943a7bafefa26a3$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




class $7ab193865b51c94a$var$FourOFourView {
    init() {
        document.title = "404 File not found";
        this.render();
    }
    render() {
        const template = (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`    

      <div class="flex-center">
        
        <div class="lost">
          <h1>Wrong Page Address?</h1>
          <p>404 url error.</p>
          <br>
          <hr>
          <br>
          <a href="/" class="link" @click=${(0, $f2dcdf3bcd0c25df$export$516b002174f6a22a)}>Home</a>
        </div>

      </div>
    `;
        (0, $e943a7bafefa26a3$export$b3890eb0ae9dca99)(template, (0, $40d943a2951875e8$export$2e2bcd8739ae039).rootEl);
    }
}
var $7ab193865b51c94a$export$2e2bcd8739ae039 = new $7ab193865b51c94a$var$FourOFourView();




class $4d78470712167616$var$Video {
    constructor(){
        this.vidList = null;
        this.mainVideos = null;
        this.watchedMain = [];
        this.watchedUpskill = [];
        this.trackerUpdates = {};
        this.fetchId = Math.random();
    }
    async getTrackVideos(type, fail = false) {
        if (this.mainVideos === null) {
            try {
                const response = await fetch("/videos/file.txt?v=" + this.fetchId);
                if (!response.ok) {
                    if (typeof fail == "function") fail();
                    return "response err";
                }
                const text = await response.text();
                this.vidList = text.split("\n");
                this.vidList.forEach((vid, i)=>{
                    this.vidList[i] = vid.split(",");
                });
                this.mainVideos = this.vidList.filter(([a, b])=>b === "main"); //destructuring 
                if (type === "main") return this.mainVideos;
                if (type === "all") return this.vidList;
            } catch (err) {
                console.log(err);
                return "catch err";
            }
            if (localStorage.watchedVideos) this.watched = localStorage.watchedVideos;
        } else {
            if (type === "main") return this.mainVideos;
            if (type === "all") return this.vidList;
        }
    }
}
var $4d78470712167616$export$2e2bcd8739ae039 = new $4d78470712167616$var$Video();


class $856e624f2acdc5f4$var$Element {
    // constructor(){
    // //   this.name = "Element"
    // //   this.myEl = document.getElementById("my-el")
    // } 
    createNewElement(el, id, classes) {
        const newEl = document.createElement(el);
        if (id) newEl.id = id;
        if (classes) {
            if (Array.isArray(classes)) classes.forEach((newClass)=>{
                newEl.classList.add(newClass);
            });
            else newEl.classList.add(classes);
        }
        return newEl;
    }
    // const newEmptyEl = Element.createNewElement('div', 'unique-div-id', 'append-div')
    appendTextNodes(el, content) {
        if (Array.isArray(content)) content.forEach((contentItem)=>{
            const newTextEl = document.createTextNode(contentItem);
            el.appendChild(newTextEl);
        });
        else {
            const newTextEl = document.createTextNode(content);
            el.appendChild(newTextEl);
        }
        return el;
    }
    // PASS IN ARRAY OR SINGLE ITEM & Empty Element or with text:
    // const elWithText = Element.appendTextNodes(occupiedEl, [' I am added', ' me too'])
    // const elWithText = Element.appendTextNodes(newEmptyEl, ' Just me added')
    replaceTextItem(el, content) {
        this.removeAllChildren(el);
        this.appendTextNodes(el, content);
    // const newTextEl = document.createTextNode(content);
    // el.firstChild.replaceWith(newTextEl)
    // return el
    }
    removeAllChildren(parent) {
        while(parent.lastChild)parent.removeChild(parent.lastChild);
    }
}
var $856e624f2acdc5f4$export$2e2bcd8739ae039 = new $856e624f2acdc5f4$var$Element();


class $4e9e683109d80965$var$HomeView {
    init() {
        // console.log('Home View.init')
        document.title = (0, $40d943a2951875e8$export$2e2bcd8739ae039).name;
        this.render();
        this.getAllVideos();
    }
    doneClick(e) {
        const watchDiv = e.target.closest(".done-click");
        const vidId = watchDiv.getAttribute("id");
        const watchImg = watchDiv.closest(".done-click").firstElementChild;
        (0, $4d78470712167616$export$2e2bcd8739ae039).trackerUpdates.id = vidId;
        if (watchImg.classList.contains("ticked")) {
            watchImg.classList.remove("ticked");
            (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain = (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain.filter((e)=>e !== vidId);
            const vidArrLength = (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain.length;
            if (vidArrLength === 0) localStorage.removeItem("watchedMainVideos");
            else localStorage.setItem("watchedMainVideos", (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain);
            (0, $4d78470712167616$export$2e2bcd8739ae039).trackerUpdates.type = "remove";
        } else {
            watchImg.classList.add("ticked");
            (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain.push(vidId);
            localStorage.setItem("watchedMainVideos", (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain.sort());
            (0, $4d78470712167616$export$2e2bcd8739ae039).trackerUpdates.type = "add";
        }
        document.dispatchEvent(new CustomEvent("update-tracker"));
        // update the 'continue/start' button
        const contButton = document.querySelector(".start-btn");
        if ((0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain.length > 0) {
            const vidId = (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain.slice(-1)[0];
            contButton.href = "#v-" + vidId;
            (0, $856e624f2acdc5f4$export$2e2bcd8739ae039).replaceTextItem(contButton, "Continue");
        } else {
            contButton.href = "#about";
            (0, $856e624f2acdc5f4$export$2e2bcd8739ae039).replaceTextItem(contButton, "Start");
        }
    }
    // Video.watchedUpskill = []
    watchClick(e) {
        const watchDiv = e.target.closest(".watched-click");
        const vidId = watchDiv.getAttribute("id");
        const watchImg = watchDiv.closest(".watched-click").lastElementChild;
        if (watchImg.classList.contains("ticked")) {
            watchImg.classList.remove("ticked");
            (0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill = (0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill.filter((e)=>e !== vidId);
            if ((0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill.length === 0) localStorage.removeItem("watchedUpskillVideos");
            else localStorage.setItem("watchedUpskillVideos", (0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill);
        } else {
            watchImg.classList.add("ticked");
            (0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill.push(vidId);
            localStorage.setItem("watchedUpskillVideos", (0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill);
        }
    }
    async getAllVideos() {
        try {
            await (0, $4d78470712167616$export$2e2bcd8739ae039).getTrackVideos("all").then(()=>{
                this.render();
                // add ticks to previous watched main videos:
                if (localStorage.watchedMainVideos) {
                    (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain = localStorage.watchedMainVideos.split(",");
                    (0, $4d78470712167616$export$2e2bcd8739ae039).watchedMain.forEach((id)=>{
                        const vidClick = document.getElementById(id).firstElementChild;
                        vidClick.classList.add("ticked");
                    });
                }
                // add ticks to previous watched upskill videos:
                if (localStorage.watchedUpskillVideos) {
                    (0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill = localStorage.watchedUpskillVideos.split(",");
                    (0, $4d78470712167616$export$2e2bcd8739ae039).watchedUpskill.forEach((id)=>{
                        const vidClick = document.getElementById(id).lastElementChild;
                        vidClick.classList.add("ticked");
                    });
                }
            });
        } catch (err) {
            console.log("Error getting videos. Please check your connection.");
            const newEmptyEl = (0, $856e624f2acdc5f4$export$2e2bcd8739ae039).createNewElement("div", "vid-error", "p4");
            const elWithText = (0, $856e624f2acdc5f4$export$2e2bcd8739ae039).appendTextNodes(newEmptyEl, "Error getting videos. Please check your internet.");
            const spinner = document.getElementsByTagName("c-spinner")[0];
            spinner.replaceWith(elWithText);
        }
    }
    scrollToClick(e) {
        e.preventDefault();
        const aTag = e.target.closest("a");
        const hrefParts = aTag.href.split("#");
        const vidId = hrefParts[1];
        document.getElementById(vidId).scrollIntoView();
    }
    render() {
        const template = (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

        <main-app-header></main-app-header>
        <main id="home-body">
          
          <div class="hero">
            <img id="hero-img" src="../images/coding-pic.svg" alt="Man Coding">
            <div id="hero-title">
              <p>web</p><p>dev</p><p>pathway</p>
            </div>
            <div id="hero-words">
              ${localStorage.watchedMainVideos == null ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`  
                <a href="#about" class="btn start-btn" @click="${this.scrollToClick}">Start</a>
              ` : (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`                 
                <a href="#v-${localStorage.watchedMainVideos.split(",").slice(-1)[0]}" @click="${this.scrollToClick}" class="btn start-btn">Continue</a>
              `}
            </div>
          </div>

          <section id="about" class="clearfix">
              <p id="q-mark">?</p>
              <h1>ABOUT the PATHWAY</h1>
              <p id="p-about">
              This web development pathway offers you a structured learning path. It provides a step-by-step approach to learning, ensuring foundational concepts are understood before moving to advanced topics.  It helps in building a strong skill set including coding, problem-solving, and debugging which are valuable for developing websites.   
              Implement best practices and become a great coder!
              <!-- As you learn, you will build projects that showcase your skills to potential employers or clients.  This pathway guides you to stay updated with the latest technologies and best practices in the field.  After completing this pathway, many career opportunities will become available including roles such as; front-end, back-end, or full-stack developer positions.            </p> -->
          </section>

          <div id="side-holder">
            <!-- <wa-ads-desktop></wa-ads-desktop> -->
            <aside>
              <h3 id="track-head">STUDY TRACKER</h3>
              <tracker-holder></tracker-holder>
            </aside>
          
            <section id="videos">

              ${(0, $4d78470712167616$export$2e2bcd8739ae039).vidList === null ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

                <br><br>
                <c-spinner spinnerSize="sp-sml"></c-spinner>

              ` : (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

                ${(0, $4d78470712167616$export$2e2bcd8739ae039).vidList.map(([id, type, image, link, title, desc], i)=>(0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`
                
                  ${type == "main" ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

                    <div id="v-${id}" class="main-vid">
                      <a href="${link}" class="main-href clearfix" target="_blank">
                          <img class="thumb" src="../images/vid-thumbs/${image}" alt="Video Thumbnail">
                          <div class="vid-info">
                            <h3 class="vid-title">${title}</h3>
                            <p class="vid-desc">${desc}</p>
                          </div>
                      </a> 
                      <div class="done-holder flex-center">
                        <div id="${id}" class="done-click flex-center" @click="${this.doneClick}">
                          <div class="done-btn flex-center "><img src="../images/tick.svg" alt="Tick"></div>
                          <div class="done-txt">done</div>
                        </div>
                      </div>
                    </div>

                  ` : (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)` 

                    <div class="up-vid">
                      <div class="up-info">
                        <p class="up-type">UPSKILL</p>
                          <a href="${link}" class="up-href" target="_blank">
                            <h4 class="up-title">${title}</h4>
                            <p class="up-desc">${desc}</p>
                          </a> 
                          <div id="${id}" class="watched-click flex-center" @click="${this.watchClick}">
                              <div class="done-txt ">watched</div>
                              <div class="done-btn flex-center"><div class="done-trick"></div><img src="../images/tick.svg" alt="Tick"></div>
                          </div>
                      </div>
                      <a class="up-thumb-box flex-center" href="${link}" target="_blank">
                        <img class="up-thumb" src="../images/vid-thumbs/${image}" alt="Video Thumbnail">
                      </a> 
                    </div>

                  `}
                
                `)}

              `}

            </section>
          </div> 

          <!-- <section>
            <wa-ads-mobile></wa-ads-mobile>
          </section> -->

          <section id="more-soon">
            <p>
              More videos coming soon...
            </p>
          </section>

        </main>
        <main-app-footer></main-app-footer>

    `;
        (0, $e943a7bafefa26a3$export$b3890eb0ae9dca99)(template, (0, $40d943a2951875e8$export$2e2bcd8739ae039).rootEl);
    }
}
var $4e9e683109d80965$export$2e2bcd8739ae039 = new $4e9e683109d80965$var$HomeView();


//set the url names 
const $f2dcdf3bcd0c25df$var$routes = {
    "404": (0, $7ab193865b51c94a$export$2e2bcd8739ae039),
    "/": (0, $4e9e683109d80965$export$2e2bcd8739ae039)
};
class $f2dcdf3bcd0c25df$var$Router {
    constructor(){
        this.routes = $f2dcdf3bcd0c25df$var$routes;
        this.lastRoute = null;
    }
    init() {
        const newRoute = window.location.pathname;
        if (this.lastRoute == newRoute) return;
        else {
            this.route(newRoute);
            this.lastRoute = newRoute;
        }
        window.addEventListener("popstate", ()=>{
            this.route(window.location.pathname);
        });
    }
    route(fullPathname) {
        const pathname = fullPathname.split("?")[0];
        const route = this.routes[pathname];
        if (route) this.routes[window.location.pathname].init();
        else this.routes["404"].init();
        //reset top of page
        const page = document.getElementById("root");
        const scrollPos = page.scrollTop;
        if (scrollPos > 20) page.scrollTo(0, 0);
    }
    gotoRoute(pathname) {
        window.history.pushState({}, pathname, window.location.origin + pathname);
        this.route(pathname);
    }
}
const $f2dcdf3bcd0c25df$var$AppRouter = new $f2dcdf3bcd0c25df$var$Router();
var $f2dcdf3bcd0c25df$export$2e2bcd8739ae039 = $f2dcdf3bcd0c25df$var$AppRouter;
function $f2dcdf3bcd0c25df$export$c8e8159b0a442f3c(pathname) {
    $f2dcdf3bcd0c25df$var$AppRouter.gotoRoute(pathname);
}
function $f2dcdf3bcd0c25df$export$516b002174f6a22a(e) {
    e.preventDefault();
    const pathname = e.target.closest("a").pathname;
    $f2dcdf3bcd0c25df$var$AppRouter.gotoRoute(pathname);
}



class $40d943a2951875e8$var$App {
    constructor(){
        this.name = "Web Dev Pathway";
        this.version = "1.0.0";
        this.apiBase = "https://ps.hashtag-webapp.com";
        this.rootEl = document.getElementById("root");
    }
    // App.clientCode 
    // Work Version
    // http://localhost:3000
    // https://ps.hashtag-webapp.com' 
    init() {
        (0, $856e624f2acdc5f4$export$2e2bcd8739ae039).removeAllChildren(this.rootEl);
        // console.log('app init')
        (0, $f2dcdf3bcd0c25df$export$2e2bcd8739ae039).init();
    }
    resizeListener() {
        document.body.style.height = window.innerHeight + "px";
        const footer = document.querySelector("main-app-footer");
        this.setSiteWidth(footer);
    }
    isMobile() {
        let viewportWidth = window.innerWidth;
        if (viewportWidth <= 768) return true;
        return false;
    }
    setSiteWidth(el) {
        const width = this.rootEl.clientWidth;
        el.style.width = width + "px";
    }
}
var $40d943a2951875e8$export$2e2bcd8739ae039 = new $40d943a2951875e8$var$App();


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9183d483313437e5$var$t = globalThis, $9183d483313437e5$export$b4d10f6001c083c2 = $9183d483313437e5$var$t.ShadowRoot && (void 0 === $9183d483313437e5$var$t.ShadyCSS || $9183d483313437e5$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $9183d483313437e5$var$s = Symbol(), $9183d483313437e5$var$o = new WeakMap;
class $9183d483313437e5$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $9183d483313437e5$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($9183d483313437e5$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $9183d483313437e5$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $9183d483313437e5$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $9183d483313437e5$export$8d80f9cac07cdb3 = (t)=>new $9183d483313437e5$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $9183d483313437e5$var$s), $9183d483313437e5$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $9183d483313437e5$export$505d1e8739bad805(o, t, $9183d483313437e5$var$s);
}, $9183d483313437e5$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($9183d483313437e5$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $9183d483313437e5$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $9183d483313437e5$export$ee69dfd951e24778 = $9183d483313437e5$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $9183d483313437e5$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $3c50cd659742dc82$var$i, defineProperty: $3c50cd659742dc82$var$e, getOwnPropertyDescriptor: $3c50cd659742dc82$var$r, getOwnPropertyNames: $3c50cd659742dc82$var$h, getOwnPropertySymbols: $3c50cd659742dc82$var$o, getPrototypeOf: $3c50cd659742dc82$var$n } = Object, $3c50cd659742dc82$var$a = globalThis, $3c50cd659742dc82$var$c = $3c50cd659742dc82$var$a.trustedTypes, $3c50cd659742dc82$var$l = $3c50cd659742dc82$var$c ? $3c50cd659742dc82$var$c.emptyScript : "", $3c50cd659742dc82$var$p = $3c50cd659742dc82$var$a.reactiveElementPolyfillSupport, $3c50cd659742dc82$var$d = (t, s)=>t, $3c50cd659742dc82$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $3c50cd659742dc82$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $3c50cd659742dc82$export$53a6892c50694894 = (t, s)=>!$3c50cd659742dc82$var$i(t, s), $3c50cd659742dc82$var$y = {
    attribute: !0,
    type: String,
    converter: $3c50cd659742dc82$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $3c50cd659742dc82$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $3c50cd659742dc82$var$a.litPropertyMetadata ??= new WeakMap;
class $3c50cd659742dc82$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $3c50cd659742dc82$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $3c50cd659742dc82$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $3c50cd659742dc82$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $3c50cd659742dc82$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($3c50cd659742dc82$var$d("elementProperties"))) return;
        const t = $3c50cd659742dc82$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($3c50cd659742dc82$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($3c50cd659742dc82$var$d("properties"))) {
            const t = this.properties, s = [
                ...$3c50cd659742dc82$var$h(t),
                ...$3c50cd659742dc82$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $9183d483313437e5$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $9183d483313437e5$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $9183d483313437e5$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $3c50cd659742dc82$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $3c50cd659742dc82$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $3c50cd659742dc82$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$3c50cd659742dc82$export$c7c07a37856565d.elementStyles = [], $3c50cd659742dc82$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $3c50cd659742dc82$export$c7c07a37856565d[$3c50cd659742dc82$var$d("elementProperties")] = new Map, $3c50cd659742dc82$export$c7c07a37856565d[$3c50cd659742dc82$var$d("finalized")] = new Map, $3c50cd659742dc82$var$p?.({
    ReactiveElement: $3c50cd659742dc82$export$c7c07a37856565d
}), ($3c50cd659742dc82$var$a.reactiveElementVersions ??= []).push("2.0.4");





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $eaddb0c0aed379ed$export$3f2f9f5909897157 extends (0, $3c50cd659742dc82$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e943a7bafefa26a3$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e943a7bafefa26a3$export$9c068ae9cc5db4e8;
    }
}
$eaddb0c0aed379ed$export$3f2f9f5909897157._$litElement$ = !0, $eaddb0c0aed379ed$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $eaddb0c0aed379ed$export$3f2f9f5909897157
});
const $eaddb0c0aed379ed$var$r = globalThis.litElementPolyfillSupport;
$eaddb0c0aed379ed$var$r?.({
    LitElement: $eaddb0c0aed379ed$export$3f2f9f5909897157
});
const $eaddb0c0aed379ed$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.4");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $75efd67fc02dc46f$export$6acf61af03e62db = !1;






customElements.define("main-app-header", class AppHeader extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    static get properties() {
        return {
            pagename: {
                type: String
            }
        };
    }
    firstUpdated() {
        super.firstUpdated();
        document.addEventListener("mobile-trackscroll", (e)=>this.scrollTracker(e));
    }
    scrollTracker(e) {
        const mobileTrackdiv = this.shadowRoot.getElementById("tracker-holder");
        const scrollable = mobileTrackdiv.scrollHeight > mobileTrackdiv.clientHeight;
        if (scrollable === true) mobileTrackdiv.scrollTo(0, e.detail);
    }
    //open side menu (clicking & scrolling is prevented)
    hamburgerClick() {
        const appMenu = this.shadowRoot.getElementById("ps-drawer");
        const holder = this.shadowRoot.getElementById("drawer-backdrop-holder");
        const backdrop = this.shadowRoot.getElementById("drawer-backdrop");
        holder.style.width = "100%";
        backdrop.style.backgroundColor = "rgb(0,0,0,0.5)";
        // this makes the menu cover the scroll bar
        let rightValue = window.innerWidth - (0, $40d943a2951875e8$export$2e2bcd8739ae039).rootEl.clientWidth;
        appMenu.style.right = "-" + rightValue + "px";
    }
    // Close side menu 
    closeMenuClick() {
        const appMenu = this.shadowRoot.getElementById("ps-drawer");
        const holder = this.shadowRoot.getElementById("drawer-backdrop-holder");
        const backdrop = this.shadowRoot.getElementById("drawer-backdrop");
        appMenu.style.right = "-100%";
        backdrop.style.backgroundColor = "rgb(0,0,0,0.0)";
        // wait half a second
        setTimeout(function() {
            holder.style.width = "0";
        }, 400);
    }
    // close menu on backdrop click
    backDropClick(e) {
        const backdrop = this.shadowRoot.getElementById("drawer-backdrop");
        // if (e === backdrop){ this.closeMenuClick() }
        this.closeMenuClick();
    }
    menuClick(e) {
        e.preventDefault();
        const currentPath = window.location.pathname;
        const pathname = e.target.closest("a").pathname;
        if (currentPath == pathname) return;
        else {
            const mobile = (0, $40d943a2951875e8$export$2e2bcd8739ae039).isMobile();
            if (mobile == true) {
                this.closeMenuClick();
                setTimeout(function() {
                    (0, $f2dcdf3bcd0c25df$export$c8e8159b0a442f3c)(pathname);
                }, 300);
            } else (0, $f2dcdf3bcd0c25df$export$c8e8159b0a442f3c)(pathname);
        }
    }
    static styles = (0, $9183d483313437e5$export$dbf350e5966cf602)`
    * { box-sizing: border-box; margin: 0px; padding: 0px; }
      .app-header { 
        width: 100%; 
        position: relative; z-index: 99;
      }
      .flex-center { display: flex; align-items: center; justify-content: center; }
      #burger-div {
        background-color: rgb(0,0,0,0.4);
        backdrop-filter: blur(5px);
        border-bottom-left-radius: 500px;
        border-bottom-right-radius: 500px;
        padding: 0.7em;
        width: 70px;
        position: absolute;
        right: 20px;
        top: 0;
        cursor: pointer;
        text-align: left; 
      }
      #burger-div svg { height: 50px;   
         stroke: var(--icon-color); }

      .header-items { 
        width: 100vw;
        position: relative; 
        text-align: right; 
      }

      #drawer-backdrop-holder{
        position: absolute;
        top: 0;
        right: 0;
        width: 0;  
        height: 100vh;
        z-index: 10;
      }

      #drawer-backdrop{
        position: relative;
        width: 100%;  
        height: 100%;
        background-color: rgb(0,0,0,0.0);
        transition: background-color .5s ease-out;
      }

      #ps-drawer {
        background-color: var(--grey-color-700);
        position: absolute;
        z-index: 99;
        height: 100vh;
        width: 50vw;
        transition: .5s ease-out;
        right: -100%;
        top: 0;
      }

      #track-head {
        font-size: 1.5em;
        margin: 30px 1em 15px 1em;
        text-align: left;
        position: absolute;
        left: 0;
      }

      #nav-wrapper {
        position: relative;
        height: 90%;
        top: 0;
        right: 0;
        padding: 0 2vh 0 0 ;
        margin: 4em 0;
        width: 100%;
        background-color: var(--tracker-background);
      }

      .close-menu {
        width: 40px;
        padding: .3em;
        position: absolute;
        cursor: pointer;
        right: 45px;
        top: -50px;
        stroke: var(--icon-color);
      }

      .app-side-menu-items img { text-align: right; margin: auto; width: 70px; margin: 3vh 0; } 

      #tracker-holder {
        display: block;
        overflow-y: scroll;
        height: 100%;
        padding: 1vh 0 3vh 0  ;
        text-align: left;
        font-size: 2em;
      }

      #tracker {
        width: 100%;
      }


      .test {
        background-color: var(--tracker-background);
      }

      ::-webkit-scrollbar { width: 15px; }
      ::-webkit-scrollbar-track { background: var(--tracker-background);}
      ::-webkit-scrollbar-thumb { background: var(--grey-color-600); }
      ::-webkit-scrollbar-thumb:hover { background: var(--completed-text); }

      /* mobile styles */
      @media all and (max-width: 768px){   



      }

      @media all and (max-width: 620px){ 
        #ps-drawer { width: 80vw; } 
      }

      @media all and (max-width: 400px){ 
        #track-head {
          margin: 30px 1em 15px 1em;
          font-size: 1.2em;
        }
      }


      /* desktop styles */
      @media all and (min-width: 769px){  
        .app-header { display: none; }        
      }
  `;
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`


    <header class="app-header">

      <div class="header-items">  
        <div id="burger-div" class="desktop-hide"  @click="${this.hamburgerClick}">    
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              height="100px" viewBox="0 0 117.333 117.667" enable-background="new 0 0 100 100" xml:space="preserve">
              <line fill="none" stroke-width="10" x1="58.5" y1="100.5" x2="58.5" y2="116"/>
              <line fill="none" stroke-width="10" x1="1" y1="58.5" x2="17" y2="58.5"/>
              <line fill="none" stroke-width="10" x1="58.5" y1="1" x2="58.5" y2="16.75"/>
              <line fill="none"  stroke-width="10" x1="99.25" y1="58.5" x2="116" y2="58.5"/>
              <circle fill="none" stroke-width="10" cx="58.5" cy="58.5" r="41.476"/>
          </svg>
        </div>

        <div id="drawer-backdrop-holder">
          <div id="drawer-backdrop" @click="${this.backDropClick}"></div>
        </div>
        <div id="ps-drawer">
          <h3 id="track-head">STUDY TRACKER</h3>

          <div id="nav-wrapper"> 

            <svg class="close-menu"  @click="${this.closeMenuClick}" alt="close" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="25px" viewBox="0 0 100 100" enable-background="new 0 0 34.25 33.875" xml:space="preserve">
                <line fill="none" stroke-width="15" stroke-linecap="round" x1="5.536" y1="5.79" x2="94.169" y2="94.422"/>
                <line fill="none" stroke-width="15" stroke-linecap="round" x1="5.388" y1="94.054" x2="94.096" y2="5.346"/>
            </svg>
            <div id="tracker-holder">
              <!-- <div id="tracker"></div> -->
              <tracker-component></tracker-component>
            </div>
          </div>
        </div>
        
      </div>



    </header>
  
    `;
    }
});





customElements.define("main-app-footer", class AppFooter extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    firstUpdated() {
        super.firstUpdated();
        this.footer = document.querySelector("main-app-footer");
        (0, $40d943a2951875e8$export$2e2bcd8739ae039).setSiteWidth(this.footer);
    }
    static styles = (0, $9183d483313437e5$export$dbf350e5966cf602)`
      * { box-sizing: border-box; margin: 0px; padding: 0px; }

      footer {
        height: 250px;
        margin-top: 30px;
        padding-top: 100px;
        padding-right: 15px;
        background: var(--footer-background);        
        color: white;
        font-size: 1.2em;
        display: flex; align-items: center; justify-content: center;
        flex-direction: column; 
        position: relative;
        
      }

      a {
        color: white;
        cursor: pointer;
      }

      nav {
        z-index: 50;
        font-weight: 400;
      }

      /* mobile styles */
      @media all and (max-width: 768px){   
        footer {
          height: 200px;
          margin-top: 30px;
          padding-top: 50px;
          font-size: 1em;
        }
      }
  
  `;
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

    <footer>
      <nav> Developed by 
        <a href="https://hashtag-webapp.com" target="_blank">
          #WEBAPP
        </a> 
      </nav>
    </footer>
  
    `;
    }
});





customElements.define("wa-ads-mobile", class WaAds extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    firstUpdated() {
        super.firstUpdated();
        this.footer = document.querySelector("main-app-footer");
        (0, $40d943a2951875e8$export$2e2bcd8739ae039).setSiteWidth(this.footer);
    }
    static styles = (0, $9183d483313437e5$export$dbf350e5966cf602)`
      * { box-sizing: border-box; margin: 0px; padding: 0px; }

      aside {
        width: auto;
        height: 20vh;
        display: flex; align-items: center; justify-content: center; 
      }

      .flip-container {
        min-width: 250px;
        height: 100%;
        background: var(--grey-100);
        position: relative;
      }

      p {
        right: -30px;
        top: 0;
        position: absolute;
        font-size: .8em;
        opacity: 0.4;
      }

      .ad-holder {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-style: preserve-3d;
        transition: all 0.8s ease;
        animation: flip 6s infinite;
      }

      @keyframes flip {
        23% {transform: rotateX(0deg)}
        27%, 73% {transform: rotateX(180deg)}
        77% {transform: rotateX(0deg)}
      }

      .ad-front {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        overflow: hidden;
        background: #ffc728;
        color: #000;
      }

      .ad-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        overflow: hidden;
        background: #fafafa;
        color: #333;
        text-align: center;
        transform: rotateX(180deg);
      }


  `;
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

    <aside>
      
      <div class="flip-container">
      <p>Ad</p>
        <div class="ad-holder">
          <div class="ad-front">
            <a href="/" class="home-button primary">Front Ad Image here</a>
          </div>

          <div class="ad-back">
            <a href="/" class="home-button primary">Back Ad Image here</a>
          </div>
      
        </div>
      </div>
    </aside>
  
    `;
    }
});





// not on home page
customElements.define("wa-ads-desktop", class WaAds extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    firstUpdated() {
        super.firstUpdated();
        this.footer = document.querySelector("main-app-footer");
        (0, $40d943a2951875e8$export$2e2bcd8739ae039).setSiteWidth(this.footer);
    }
    static styles = (0, $9183d483313437e5$export$dbf350e5966cf602)`
      * { box-sizing: border-box; margin: 0px; padding: 0px; }

      aside {
        top: 20vh;
        position: sticky;
      }

      aside > div {
        right: 0;
        top: 100px;
        width: 15vw;
        height: auto;
        position: absolute;
      }

      p {
        right: 5px;
        top: 72px;
        position: absolute;
        font-size: .8em;
        opacity: 0.4;
      }

      .flip-container {
        width: 100%;
        height: 350px;
        background: var(--grey-100);
        position: relative;
      }



      .ad-holder {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-style: preserve-3d;
        transition: all 0.8s ease;
        animation: flip 6s infinite;
      }

      @keyframes flip {
        23% {transform: rotateY(0deg)}
        27%, 73% {transform: rotateY(180deg)}
        77% {transform: rotateY(0deg)}
      }

      .ad-front {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        overflow: hidden;
        background: #ffc728;
        color: #000;
      }

      .ad-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        overflow: hidden;
        background: #fafafa;
        color: #333;
        text-align: center;
        transform: rotateY(180deg);
      }

      /* mobile styles */
      @media all and (max-width: 768px){   


      }
  
  `;
    // a {
    //   position: absolute;
    //   top: 0;
    //   right: 0:
    //   border: 1px solid grey;
    //   background-color: yellow;
    //   height: auto;
    //   width: 11vw;
    // }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

    <aside>
      <p>Ad</p>

      <div>
        <div class="flip-container">
          <div class="ad-holder">
            <div class="ad-front">
              <a href="/" class="home-button primary">Front Ad Image here</a>
            </div>

            <div class="ad-back">
              <a href="/" class="home-button primary">Back Ad Image here</a>
            </div>
        
          </div>
        </div>
      </div>
    </aside>
  
    `;
    }
});





customElements.define("tracker-holder", class TrackHolder extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    // static get properties(){
    //   return {
    //     // pagename: {
    //     //   type: String
    //     // }
    //   }
    // }
    firstUpdated() {
        super.firstUpdated();
        document.addEventListener("desktop-trackscroll", (e)=>this.scrollTracker(e));
    }
    scrollTracker(e) {
        const desktopTrackdiv = this.shadowRoot.getElementById("tracker-wrap");
        const scrollable = desktopTrackdiv.scrollHeight > desktopTrackdiv.clientHeight;
        if (scrollable === true) desktopTrackdiv.scrollTo(0, e.detail);
    }
    // POSITION EQUATION: n * 55 - 50 
    //  .p1 { top: 5px; }
    // .track-btn - scale: 1.25; // animate size when moving 
    static styles = (0, $9183d483313437e5$export$dbf350e5966cf602)`

    #tracker-wrap {
      position: relative;
      width: 250px;
      height: calc(100vh - 150px);
      overflow-y: auto;
      z-index: 10;
    }

    ::-webkit-scrollbar { width: 15px; }
    ::-webkit-scrollbar-track { background: var(--tracker-background);}
    ::-webkit-scrollbar-thumb { background: var(--grey-color-600); }
    ::-webkit-scrollbar-thumb:hover { background: var(--completed-text); }

  `;
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

      <div id="tracker-wrap">
        
        <tracker-component></tracker-component>
      </div>
  
    `;
    }
});







customElements.define("tracker-component", class Tracker extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    // static get properties(){
    //   return {
    //     pagename: {
    //       type: String
    //     }
    //   }
    // }
    firstUpdated() {
        super.firstUpdated();
        this.trackVideos = null;
        this.tracker = this.shadowRoot.getElementById("track-vids-box");
        this.getTrackVideos();
        document.addEventListener("update-tracker", ()=>this.updateTracker());
    }
    updateTracker() {
        // console.log('run update tracker function')
        this.repositionButton((0, $4d78470712167616$export$2e2bcd8739ae039).trackerUpdates.type);
    }
    async getTrackVideos() {
        let watched = [];
        // console.log(localStorage.watchedMainVideos)
        if (localStorage.watchedMainVideos) watched = localStorage.watchedMainVideos.split(",");
        try {
            await (0, $4d78470712167616$export$2e2bcd8739ae039).getTrackVideos("main").then(()=>{
                (0, $4d78470712167616$export$2e2bcd8739ae039).mainVideos.forEach(([id, type, image, link, title, desc], i)=>{
                    const el = document.createElement("a");
                    el.id = `t-${id}`;
                    el.className = `t-vid p${i + 2}`;
                    el.href = `#v-${id}`;
                    let doneClasses = "t-done-box";
                    if (watched.length > 0 && watched.includes(id)) doneClasses = "t-done-box t-ticked";
                    el.innerHTML = `
                  <div class="${doneClasses}">
                    <div class="t-target"></div>
                    <img src="../images/tick.svg" alt="Tick">
                  </div>
                  <p class="t-title">${title}</p>
                `;
                    el.addEventListener("click", this.scrollToClick.bind(this));
                    this.tracker.append(el);
                });
                this.tracker.style.height = ((0, $4d78470712167616$export$2e2bcd8739ae039).mainVideos.length + 1) * 55 + 50 + "px";
                this.repositionButton("init");
            });
        } catch (err) {
            console.log("Error getting videos");
            const newEmptyEl = (0, $856e624f2acdc5f4$export$2e2bcd8739ae039).createNewElement("div", "vid-error", "p4");
            const elWithText = (0, $856e624f2acdc5f4$export$2e2bcd8739ae039).appendTextNodes(newEmptyEl, "Error getting videos. Please check your internet.");
            this.tracker.append(elWithText);
        }
    }
    // can refactor for 'add' and 'remove' switch by passing in a detail object with the event listener
    // ... instead of using Video.trackerUpdates.id  & Video.trackerUpdates.type
    repositionButton(type) {
        let move = true // allows the function to cancel when false
        ;
        let i = 0 //get number of array items to reposition the start button
        ;
        const nextButton = this.shadowRoot.getElementById("next-btn");
        let nextPosObject = this.getPosAndClass(nextButton.classList);
        const checkButtons = this.shadowRoot.querySelectorAll(".t-done-box");
        switch(type){
            case "init":
                // get number of consecutive ticked divs to move on init
                while(move === true && i < (0, $4d78470712167616$export$2e2bcd8739ae039).mainVideos.length)if (checkButtons[i].classList.contains("t-ticked")) i++;
                else move = false;
                if (i === 0) return;
                // get all number of divs before the button and move them above the button
                let d = 0;
                while(d < i){
                    this.swapPosClasses("p" + (d + 2), "p" + (d + 1));
                    d++;
                }
                // move the button below the ticked divs
                nextButton.classList.replace("p1", "p" + (i + 1));
                //updating the href link for the next lesson
                if (i < (0, $4d78470712167616$export$2e2bcd8739ae039).mainVideos.length) nextButton.href = "#v-" + (0, $4d78470712167616$export$2e2bcd8739ae039).mainVideos[i][0];
                else nextButton.href = "#v-" + (0, $4d78470712167616$export$2e2bcd8739ae039).mainVideos[i - 1][0];
                //scrolling button into view for better UX
                if (i >= 5) {
                    const mobile = (0, $40d943a2951875e8$export$2e2bcd8739ae039).isMobile();
                    if (mobile === true) document.dispatchEvent(new CustomEvent("mobile-trackscroll", {
                        "detail": i * 55
                    }));
                    else document.dispatchEvent(new CustomEvent("desktop-trackscroll", {
                        "detail": i * 55
                    }));
                }
                break;
            case "add":
                {
                    // add tick class from  Video.trackerUpdates.id
                    const updateVid = this.shadowRoot.getElementById("t-" + (0, $4d78470712167616$export$2e2bcd8739ae039).trackerUpdates.id);
                    updateVid.firstElementChild.classList.add("t-ticked");
                    // use nextPosObject to get the button in the next position
                    let afterNext = this.shadowRoot.querySelector(".p" + (nextPosObject.number + 1));
                    move = true;
                    let i = 0;
                    // while(move === true && i < 10){ // used this for testing
                    while(move === true){
                        // continue until next div not ticket or null
                        if (afterNext == null) {
                            // console.log('no more divs');
                            move = false;
                            return;
                        } else if (afterNext.firstElementChild.classList.contains("t-ticked")) {
                            // swap classes here
                            nextButton.classList.replace(nextPosObject.class, "p" + (nextPosObject.number + 1));
                            afterNext.classList.replace("p" + (nextPosObject.number + 1), nextPosObject.class);
                            // reset new element data
                            nextPosObject = this.getPosAndClass(nextButton.classList);
                            afterNext = this.shadowRoot.querySelector(".p" + (nextPosObject.number + 1));
                        // i++; // to prevent browser from crashing while testing
                        } else move = false;
                    }
                    //update href to next video
                    nextButton.href = "#v" + afterNext.getAttribute("id").slice(1);
                    // animate nextButton 
                    nextButton.classList.add("move-btn");
                    setTimeout(()=>{
                        nextButton.classList.remove("move-btn");
                    }, 400);
                    break;
                }
            case "remove":
                {
                    // remove tick class from  Video.trackerUpdates.id
                    const updateVid = this.shadowRoot.getElementById("t-" + (0, $4d78470712167616$export$2e2bcd8739ae039).trackerUpdates.id);
                    updateVid.firstElementChild.classList.remove("t-ticked");
                    //check if the updated vid is positioned before the button 
                    const vidPosObject = this.getPosAndClass(updateVid.classList);
                    nextPosObject = this.getPosAndClass(nextButton.classList);
                    // if so, move the buttons 
                    if (vidPosObject.number < nextPosObject.number) {
                        // console.log('move next button')
                        const m = nextPosObject.number - vidPosObject.number;
                        // console.log('move: ' + m)
                        // ANIMATE THE NEXT BUTTON "SCALE"
                        nextButton.classList.add("move-btn");
                        setTimeout(()=>{
                            nextButton.classList.remove("move-btn");
                        }, 400);
                        let n = 0; // for number of moves
                        while(n < m){
                            // console.log('swapping classes')
                            //get nextButton pos class
                            this.swapPosClasses("p" + (nextPosObject.number - 1), nextPosObject.class);
                            nextButton.classList.replace(nextPosObject.class, "p" + (nextPosObject.number - 1));
                            // update nextbuttonPos
                            nextPosObject = this.getPosAndClass(nextButton.classList);
                            n++;
                        }
                        // update "next Button" href
                        const getNextId = this.shadowRoot.querySelector(".p" + (nextPosObject.number + 1));
                        nextButton.href = "#v" + getNextId.getAttribute("id").slice(1);
                    }
                    break;
                }
            default:
                return;
        }
    }
    getPosAndClass(classList) {
        let posObject = {} // posObject.class posObject.number
        ;
        classList.forEach((className)=>{
            if (className[0] === "p") {
                posObject.class = className;
                posObject.number = Number(className.substring(1));
            }
        });
        return posObject;
    }
    swapPosClasses(currentClass, newClass) {
        const posDiv = this.shadowRoot.querySelector("." + currentClass);
        posDiv.classList.replace(currentClass, newClass);
    }
    scrollToClick(e) {
        e.preventDefault();
        const aTag = e.target.closest("a");
        const hrefParts = aTag.href.split("#");
        const vidId = hrefParts[1];
        document.getElementById(vidId).scrollIntoView();
    }
    // POSITION EQUATION: n * 55 - 50 // .p1 { top: 5px; } etc...
    // .track-btn - scale: 1.25; // animate size when moving 
    static styles = (0, $9183d483313437e5$export$dbf350e5966cf602)`

    #the-tracker{
      background-color: var(--tracker-background);
    }

 
    #track-vids-box {
      position: relative;
    }

    .t-vid {
      border: solid 1px var(--grey-color-600);
      border-radius: 5px;
      background-color: var(--grey-color-800);
      left: .3em; 
      right: .3em;
      height: 50px;
      position: absolute;
      text-decoration: none;
      transition: all 0.8s ease;
    }

    .t-done-box { 
        width: 50px; 
        height: 50px; 
        float: left;
        display: flex; align-items: center; justify-content: center; 
    }
    
    .t-target {
        position: absolute;
        top: 10px;
        left: 10px;
        background-color: var(--grey-color-900);
        border-radius: 500px;
        width: 30px; 
        height: 30px;
        z-index: 20;
    }
    
    .t-done-box img { 
        opacity: 0;
        width: 10px;
        z-index: 100;
        transition: all 300ms ease-in;
    }
    .t-ticked img { width: 40px; height: 40px; opacity: 1; }

    .p1 { top: 5px; }
    .p2 { top: 60px; }
    .p3 { top: 115px; }
    .p4 { top: 170px; }
    .p5 { top: 225px; }

    .p6 { top: 280px; }
    .p7 { top: 335px; }
    .p8 { top: 390px; }
    .p9 { top: 445px; }
    .p10 { top: 500px; }

    .p11 { top: 555px; }
    .p12 { top: 610px; }
    .p13 { top: 665px; }
    .p14 { top: 720px; }
    .p15 { top: 775px; }

    .p16 { top: 830px; }
    .p17 { top: 885px; }
    .p18 { top: 940px; }
    .p19 { top: 995px; }
    .p20 { top: 1050px; }

    .p21 { top: 1105px; }
    .p22 { top: 1160px; }
    .p23 { top: 1215px; }
    .p24 { top: 1270px; }
    .p25 { top: 1325px; }

    .p26 { top: 1380px; }
    .p27 { top: 1435px; }
    .p28 { top: 1490px; }
    .p29 { top: 1545px; }
    .p30 { top: 1600px; }

    .p31 { top: 1655px; }
    .p32 { top: 1710px; }
    .p33 { top: 1765px; }
    .p34 { top: 1820px; }
    .p35 { top: 1875px; }

    .p36 { top: 1930px; }
    .p37 { top: 1985px; }
    .p38 { top: 2040px; }
    .p39 { top: 2095px; }
    .p40 { top: 2150px; }

    .track-btn {
        margin-top: 6px;
        position: absolute;
        left: 1.5em; 
        right: 1.5em;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        scale: 1;
        z-index: 50;
        transition: all 0.8s ease-in-out;
    }

    .move-btn {
        scale: 1.1;
    }
    


    .t-title {
        margin: 13px 3px 13px 0;
        font-size: 18px;
        white-space: nowrap;  
        overflow: hidden;       
        text-overflow: ellipsis;
        color: var(--text-color);
    }

    .btn {
      background-color: var(--action-color);
      border-radius: 500px;
      padding: 0.5em;
      color: white;
      font-family: 'Trebuchet MS', 'Gill Sans', Calibri, 'Gill Sans MT', sans-serif;
      outline: none;
      border:none; 
      text-decoration: none;
    }

    #vid-error {
      padding: 5em 1em;
    }

  `;
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`

      <div id="the-tracker">
        <div id="track-vids-box">
          <a id="next-btn" href="#v-vid01" @click="${this.scrollToClick}" class="btn track-btn p1">Next >></a>
          <!-- insert links here -->
        </div>
      </div>
  
    `;
    }
});



customElements.define("c-spinner", class Features extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static get properties() {
        return {
            spinnerSize: {
                type: String
            }
        };
    }
    static styles = (0, $9183d483313437e5$export$dbf350e5966cf602)`

    * { box-sizing: border-box; margin: 0px; padding: 0px; }

    .spinner{
      border-top: 4px solid var(--brand-color-500);
      border-right: 4px solid transparent;
      border-radius: 50%;
      animation: rotation .8s linear infinite;
      margin: 20px auto;
      height: 70px; width: 70px;
    }

    @keyframes rotation{
      from{ transform: rotate(0deg); }
      to{ transform: rotate(360deg); }
    }

    .sp-lg { height: 115px; width: 115px; }
    .sp-sml { height: 50px; width: 50px; }
  
  `;
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`
      <style>      
      

      </style>

      <div class="spinner ${this.spinnerSize}"></div>

    `;
    }
});



document.addEventListener("DOMContentLoaded", ()=>{
    (0, $40d943a2951875e8$export$2e2bcd8739ae039).init();
});
window.addEventListener("resize", ()=>{
    (0, $40d943a2951875e8$export$2e2bcd8739ae039).resizeListener();
});


//# sourceMappingURL=index.4fd575fe.js.map
